// GridDiscoverUsers.jsx
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import LoadingImageResource from '../../img/img_loading_white_20.svg';
import {
  InfiniteScroller,
  ScrollItem,
} from '../component/InfiniteScroller.jsx';
import UserFeedItem from '../container/UserFeedItem.js';
import defaults from '../resource/defaults.js';

export const GridDiscoverUsers = ({
  nextPage = null,
  isNextPageFetching = false,
  userIds = defaults.EMPTY_ARRAY,
  category = null,
  isAuthed = false,
  withChatLink = false,
  fetchFeeds = defaults.NULL_FUNCTION,
  ...otherProps
}) => {
  const loadMore = () => {
    if (category) {
      return fetchFeeds({ type: category, page: nextPage });
    }
  };

  useEffect(() => {
    if (!category) return;

    const nextTick = setTimeout(() => {
      fetchFeeds({ type: category, page: 1 });
    }, 0);

    return () => {
      clearTimeout(nextTick);
    };
  }, [isAuthed, category, fetchFeeds]);

  return (
    <StyledGridDiscoverUsers>
      <ScrollerWrapper>
        <InfiniteScroller
          pageStart={1}
          threshold={100}
          hasMore={nextPage != null}
          isFetching={isNextPageFetching}
          loadMore={loadMore}
        >
          <ListWrapper>
            <ScrollItem
              loader={
                <UserWrapper>
                  <LoadingWrapper>
                    <LoadingIcon src={LoadingImageResource} alt="loading" />
                  </LoadingWrapper>
                </UserWrapper>
              }
            >
              {userIds.map((userId, index) => (
                <UserFeedItemWrapper key={userId} withChatLink={withChatLink}>
                  <UserFeedItem
                    id={userId}
                    withChatLink={withChatLink}
                    categoryId={category}
                    itemIndexInCategory={index}
                    {...otherProps}
                  />
                </UserFeedItemWrapper>
              ))}
            </ScrollItem>
          </ListWrapper>
        </InfiniteScroller>
      </ScrollerWrapper>
    </StyledGridDiscoverUsers>
  );
};

GridDiscoverUsers.propTypes = {
  userIds: PropTypes.array,
  category: PropTypes.string,
  nextPage: PropTypes.number,
  isNextPageFetching: PropTypes.bool,
  isAuthed: PropTypes.bool,
  withChatLink: PropTypes.bool,
  fetchFeeds: PropTypes.func,
};

const StyledGridDiscoverUsers = styled.main``;

const ScrollerWrapper = styled.div`
  padding-right: 16px;
  padding-left: 16px;
  padding-bottom: 20px; // updated to 20 based on design team's feedback (2024.02)
`;

const ListWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(104px, 1fr));
  grid-column-gap: 8px;
  grid-row-gap: 20px;
`;

const UserWrapper = styled.div``;

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  opacity: 0.6;
`;

const LoadingIcon = styled.img`
  width: 32px;
  height: auto;
`;

const UserFeedItemWrapper = styled.div`
  cursor: ${({ withChatLink }) => (withChatLink ? 'pointer' : 'auto')};
`;

export default GridDiscoverUsers;
